import {
  createGenericProblemDetails,
  isProblemDetailsWithErrorCode,
} from '@shared/errors/index.ts';
import axios from 'axios';

type ProblemDetailsLike = {
  detail?: string | null;
  title?: string | null;
  status?: number | null;
  [key: string]: unknown;
};

const isProblemDetailsLike = (responseData: unknown): responseData is ProblemDetailsLike => {
  return (
    typeof responseData === 'object' &&
    responseData !== null &&
    ('detail' in responseData || 'title' in responseData || 'status' in responseData)
  );
};

export const parseProblemDetails = (error: unknown) => {
  if (!error) {
    throw new Error('empty error object');
  }
  if (axios.isAxiosError(error) && error.response) {
    const responseData = error.response.data;
    if (isProblemDetailsWithErrorCode(responseData)) {
      return responseData;
    }
    if (isProblemDetailsLike(responseData)) {
      return {
        ...createGenericProblemDetails(error.response.status ?? 500),
        ...responseData,
        errorCode: 'GENERAL',
      };
    }
  }

  return createGenericProblemDetails(500); // TODO: is it safe to say it's 500?
};
